import { useTranslation } from 'react-i18next';

// Google's Terms of Service require this disclosure wherever the badge
// (.grecaptcha-badge, hidden in src/index.css) is not visibly shown.
export const RecaptchaNotice = () => {
  const { t } = useTranslation();
  return (
    <p className="wreg-foot-legal-terms wreg-foot-recaptcha">{t('general.recaptcha-notice')}</p>
  );
};
